import { Button } from "@mui/material";
import { Receipt } from "@mui/icons-material";

import BillingReportModal from "./modals/BillingReportModal";
import useBillingReport from "./hooks/useBillingReport";

const BillingReport = () => {
  const { showBillingReportModal, openModal, closeModal } = useBillingReport();

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          openModal();
        }}
        startIcon={<Receipt />}
        style={{ marginRight: "10px" }}
      >
        Generate Billing Report
      </Button>

      {showBillingReportModal && <BillingReportModal onClose={closeModal} />}
    </>
  );
};

export default BillingReport;
